import { push, goBack, replace } from 'connected-react-router';
// jl-design-system
import { submitForm, resetForm } from 'jl-design-system/redux/actions/form/formActions';
import stripWhitespace from 'jl-design-system/utils/string/stripWhitespace';
import transformUkPhoneNumber from 'jl-design-system/form/normalizers/transformUkPhoneNumber';

// lodash
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';
//
import {
  ANALYTICS_COLLECTION_POINT_DOWN,
  ANALYTICS_COLLECTION_POINT_CUT_OFF_MODAL_SHOWN,
  ANALYTICS_COLLECTION_POINT_SUCCESS,
  ANALYTICS_FIND_COLLECTION_POINT_FAILED,
  SET_COLLECTION_POINT_VIEW_TYPE,
  CLEAR_COLLECTION_POINT_SELECTION,
  FILTER_COLLECTION_POINTS,
  FIND_COLLECTION_POINT,
  GET_COLLECTION_POINT_DETAILS,
  SELECT_COLLECTION_POINT,
  SET_FIND_COLLECTION_POINT_ERROR,
  NEW_COLLECTION_POINT_SEARCH,
  PUT_CC_DELIVERY_DETAILS,
  PUT_CC_DELIVERY_DETAILS_SILENTLY,
  SET_ACTIVE_MAP_MARKER,
  SET_ACTIVE_MODAL_MAP_MARKER,
  GET_COLLECTION_POINT_DATES,
  SET_CLICK_COLLECT_COUNTDOWN_VISIBILITY,
  SET_CLICK_COLLECT_CUT_OFF_PASSED,
  SET_CLICK_COLLECT_CUT_OFF_PASSED_MODAL_VISIBILITY,
  DELETE_COLLECTION_POINT,
  SHOW_REMOVE_COLLECTION_POINT_OVERLAY,
  HIDE_REMOVE_COLLECTION_POINT_OVERLAY,
  GET_SAVED_COLLECTION_POINTS,
  SET_GEO_LOCATION_SEARCH_ACTIVE_STATUS,
  SET_COLLECT_PLUS_SELECTED_DATE,
  GOOGLE_MAPS_SCRIPT_LOADED,
} from '../../../constants/actionConstants';
import { VIEW_TYPE_MAP, COLLECT_PLUS_OWNER_ID } from '../../../constants/clickCollectConstants';
import {
  getUnavailableStores,
  getUnavailableStoresAnalyticsInfo,
  selectClickAndCollectStoreAnalytics,
} from '../../../utils/analytics/utils/getCollectionAnalytics';
import {
  URL_COLLECTION_POINTS,
  URL_COLLECTION_POINT_BY_ID,
  URL_COLLECTION_DETAILS,
  URL_CUSTOMER_COLLECTION_POINTS,
  URL_COLLECTION_DATES,
  URL_DELETE_COLLECTION_POINT,
} from '../../../constants/endpointConstants';
import triggerAnalyticsEvent from '../analytics/analyticsAction';
import { initPaymentPage } from '../payment/orderFormActions';
import routeConstants from '../../../constants/routeConstants';
import getGiftMessageLines from '../../../utils/delivery/getGiftMessageLines';
import errorCodeConstants from '../../../constants/errorCodeConstants';
import featureConstants from '../../../constants/featureConstants';
import { isFeatureActive } from '../../reducers/config/configReducer';
import handleInconsistentOrderFormState from '../../../utils/orderform/handleInconsistentOrderFormState';
import daysBetweenDateAndStartOfWeek from '../../../utils/helpers/date/daysBetweenDateAndStartOfWeek';
import sortCollectionPointsByDistance from '../../../utils/collection/sortCollectionPointsByDistance';
import { COLLECTOR_DETAILS_FORM_ID } from '../../../utils/form/configs/collectorDetails';

export function getClickCollectCollectionPoints(unfilteredCollectionPoints = []) {
  const filteredCollectionPoints = unfilteredCollectionPoints.filter(
    point => point.ownerId !== COLLECT_PLUS_OWNER_ID,
  );

  return sortCollectionPointsByDistance(filteredCollectionPoints);
}

export function getCollectPlusCollectionPoints(unfilteredCollectionPoints = []) {
  const filteredCollectionPoints = unfilteredCollectionPoints.filter(
    point => point.ownerId === COLLECT_PLUS_OWNER_ID,
  );

  return sortCollectionPointsByDistance(filteredCollectionPoints);
}

export const determinePreSelectedCollectionPoint = (userCollectionPoints) => {
  if (userCollectionPoints.length > 0) {
    const userSelectedDefaultCollectionPoint = find(userCollectionPoints, {
      isDefault: true,
    });

    if (userSelectedDefaultCollectionPoint) {
      return userSelectedDefaultCollectionPoint;
    }

    if (userCollectionPoints[0]) {
      return userCollectionPoints[0];
    }
  }

  return undefined;
};

export const submitCCDeliveryDetails = body => (dispatch, getState) => {

  // analytics details
  let detailsToKeep = {
    clickandCollectType: 'standard',
  };

  const collectionPoint = get(getState(), 'clickAndCollect.selectedCollectionPoint', {});
  const selectedCollectionTime = get(getState(), 'clickAndCollect.selectedCollectionTime');
  const collectionPointDates = get(getState(), 'clickAndCollect.collectionPointDates');

  if (selectedCollectionTime && collectionPointDates) {
    const firstDateInCollectionPointDates = get(collectionPointDates, '[0].date');
    const firstAvailableDay = daysBetweenDateAndStartOfWeek(firstDateInCollectionPointDates);
    const selectedDaysUntilDelivery = daysBetweenDateAndStartOfWeek(selectedCollectionTime);

    detailsToKeep = {
      firstAvailableDay,
      clickandCollectType: 'named day',
      selectedDaysUntilDelivery,
      deliveryMessage: 'Click and Collect',
    };
  }

  return dispatch({
    type: PUT_CC_DELIVERY_DETAILS,
    request: client => client({ path: URL_COLLECTION_DETAILS, config: { method: 'PUT', body } }),
    collectionPoint,
    body,
    ...detailsToKeep,
  });
};

export const setCutOffPassedModalVisibility = visible => (dispatch) => {
  dispatch({
    type: SET_CLICK_COLLECT_CUT_OFF_PASSED_MODAL_VISIBILITY,
    visible,
  });

  if (visible) {
    dispatch(triggerAnalyticsEvent(ANALYTICS_COLLECTION_POINT_CUT_OFF_MODAL_SHOWN));
  }
};

export const submitClickAndCollectDeliveryDetails = (formValues = {}) => async (dispatch, getState) => (
  new Promise(async (resolve) => {
    const countdownVisible = get(getState(), 'clickAndCollect.countdownVisible');
    const cutOffPassed = get(getState(), 'clickAndCollect.cutOffPassed');
    const showCutOffPassedModal = get(getState(), 'clickAndCollect.showCutOffPassedModal');

    if (cutOffPassed && countdownVisible && !showCutOffPassedModal) {
      dispatch(setCutOffPassedModalVisibility(true));
      resolve();
    } else {
      const suggestedNewCollectionDate = get(getState(), 'clickAndCollect.suggestedNewCollectionDate');
      const selectedCollectionDate = get(getState(), 'clickAndCollect.selectedCollectionDate', {});
      const collectionPointDates = get(getState(), 'clickAndCollect.collectionPointDates');

      const { giftReceipt, giftMessage, ...rest } = formValues;

      const collectorDetails = {
        ...rest,
        giftMessageLines: getGiftMessageLines(giftReceipt, giftMessage),
      };

      const fulfilmentOfferId = cutOffPassed ?
        suggestedNewCollectionDate.fulfilmentOfferId :
        selectedCollectionDate.fulfilmentOfferId || get(collectionPointDates, '[0].fulfilmentOfferId');

      const body = {
        collectorDetails: {
          primaryPhone: stripWhitespace(transformUkPhoneNumber(collectorDetails.phoneNumber || '')),
        },
        fulfilment: {
          fulfilmentOfferId,
          giftMessageLines: collectorDetails.giftMessageLines,
        },
      };

      await dispatch(submitForm(COLLECTOR_DETAILS_FORM_ID));

      const syncErrors = get(getState(), `form[${COLLECTOR_DETAILS_FORM_ID}].syncErrors`, {});

      if (isEmpty(syncErrors)) {
        const response = await dispatch(submitCCDeliveryDetails(body));

        const pathname = get(getState(), 'router.location.pathname', '');
        if (
          response.type === `${PUT_CC_DELIVERY_DETAILS}.SUCCESS` &&
          pathname.indexOf(routeConstants.PAYMENT) === -1
        ) {
          dispatch(initPaymentPage(null, null, true));
        }
        if (response.type === `${PUT_CC_DELIVERY_DETAILS}.FAILED`) {
          if (get(response, 'error.code') === errorCodeConstants.ORDER_FORM_INCONSISTENT_STATE) {
            await dispatch(handleInconsistentOrderFormState());
          } else {
            dispatch(push(routeConstants.DELIVERY));
          }
        }
      }

      resolve();
    }
  })
);

export const getCollectionPointById = (collectionPointSearchTerm, refresh = false) => async (dispatch, getState) => {
  const alwaysShowCollectPlusFeatureActive = isFeatureActive(getState(), featureConstants.ALWAYS_SHOW_COLLECT_PLUS);

  return dispatch({
    type: FIND_COLLECTION_POINT,
    collectionPointSearchTerm,
    request: client => client({
      path: URL_COLLECTION_POINTS(collectionPointSearchTerm),
      config: { method: 'GET' },
    }),
    refresh,
    alwaysShowCollectPlusFeatureActive,
  });
};

export const findCollectionPoint = (collectionPointSearchTerm, refresh = false) => async (dispatch, getState) => {
  const response = await dispatch(getCollectionPointById(collectionPointSearchTerm, refresh));

  if (response.type === `${FIND_COLLECTION_POINT}.FAILED`) {
    dispatch(triggerAnalyticsEvent(ANALYTICS_COLLECTION_POINT_DOWN));
    if (response.error.code !== errorCodeConstants.INCOMPLETE_COLLECTION_SEARCH) {
      dispatch(push(routeConstants.DELIVERY));
    }
  }

  if (response.type === `${FIND_COLLECTION_POINT}.SUCCESS`) {
    const collectionPointsFound = get(response.result, 'collectionPoints', []).length;
    if (!collectionPointsFound) {
      dispatch(triggerAnalyticsEvent(ANALYTICS_FIND_COLLECTION_POINT_FAILED));
      return;
    }

    const searchNewCollectPoint = getState().clickAndCollect.collectionPointSearchTerm;
    const collectionPointSearchResults = getState().clickAndCollect.collectionPointSearchResults;
    const clickCollectCollectionPoints = getClickCollectCollectionPoints(collectionPointSearchResults);
    const collectPlusCollectionPoints = getCollectPlusCollectionPoints(collectionPointSearchResults);
    const unavailableStores = getUnavailableStores(collectionPointSearchResults);

    const deliveryProposition = {
      method: 'col',
      selected: 1,
      deliveryId: '',
      message: '',
      searchTerm: searchNewCollectPoint,
      ccShopsShown: clickCollectCollectionPoints.length,
      cpShopsShown: collectPlusCollectionPoints.length,
    };

    deliveryProposition.countdownVisible = !!getState().clickAndCollect.countdownVisible;

    dispatch(triggerAnalyticsEvent(ANALYTICS_COLLECTION_POINT_SUCCESS, {
      analytics: {
        checkout: {
          batch: [{
            deliveryProposition: [deliveryProposition],
          }],
        },
        error: unavailableStores.map(item => ({
          type: 'checkout:info',
          message: getUnavailableStoresAnalyticsInfo(item),
        })),
      },
    }));
  }
};

export const filterCollectionPoints = () => ({
  type: FILTER_COLLECTION_POINTS,
});

export const newCollectionPointSearch = () => ({
  type: NEW_COLLECTION_POINT_SEARCH,
});

// used when C&C store is selected and partner discount is toggled on/off
// used when edit basket could have caused a change in collection point charges
export const getCollectionPointDetails = collectionPointId => ({
  type: GET_COLLECTION_POINT_DETAILS,
  request: client => client({ path: URL_COLLECTION_POINT_BY_ID(collectionPointId), config: { method: 'GET' } }),
});

export const getSavedCollectionPoints = () => ({
  type: GET_SAVED_COLLECTION_POINTS,
  request: client => client({ path: URL_CUSTOMER_COLLECTION_POINTS, config: { method: 'GET' } }),
});

export const getCollectionPointDates = body => ({
  type: GET_COLLECTION_POINT_DATES,
  request: client => client({ path: URL_COLLECTION_DATES, config: { method: 'POST', body } }),
  selectingCollectionPointId: body.collectionPointId,
});

export const selectCollectionPoint = ({
  collectionPoint: _collectionPoint,
  refresh = false,
  selectedIndex,
}) => async (dispatch, getState) => {

  let collectionPoint = { ..._collectionPoint };

  if (refresh) {
    const getDetails = await dispatch(getCollectionPointDetails(collectionPoint.id));

    if (getDetails.type === `${GET_COLLECTION_POINT_DETAILS}.SUCCESS`) {
      collectionPoint = getDetails.result.collectionPoints[0];
    }

    if (getDetails.type === `${GET_COLLECTION_POINT_DETAILS}.FAILED`) {
      dispatch(push(routeConstants.DELIVERY));
      return;
    }
  }

  if (collectionPoint.isAvailable) {
    await dispatch(getCollectionPointDates({
      batchId: get(getState(), 'delivery.deliveries[0].id'),
      collectionPointId: collectionPoint.id,
    }));
  }

  const searchTerm = get(getState(), 'clickAndCollect.collectionPointSearchTerm');
  const collectionDates = get(getState(), 'clickAndCollect.collectionPointDates');
  const analytics = selectClickAndCollectStoreAnalytics(
    collectionPoint,
    searchTerm,
    collectionDates,
    selectedIndex,
  );

  await dispatch({
    type: SELECT_COLLECTION_POINT,
    collectionPoint,
    analytics,
  });

  if (collectionPoint.ownerId === COLLECT_PLUS_OWNER_ID && refresh) {
    const date = get(collectionDates, '[0].date');

    if (date) {
      // Collect+ stores don't show a calendar but we get dates anyway for fulfilmentOfferId reasons
      // then 'select' the first available date for the customer
      dispatch({
        type: SET_COLLECT_PLUS_SELECTED_DATE,
        payload: date,
      });
    }
  }

  if (refresh) {
    return;
  }

  const collectorDetailsForm = get(getState().form, `${COLLECTOR_DETAILS_FORM_ID}`, {});
  const formValuePhoneNumber = get(collectorDetailsForm, 'values.phoneNumber', '');
  dispatch(resetForm(COLLECTOR_DETAILS_FORM_ID, { phoneNumber: formValuePhoneNumber }));

  const url = routeConstants.CLICK_AND_COLLECT_STORE_SELECTED.replace(':id', collectionPoint.id);
  dispatch(push(url));
};

export const clearCollectionPointSelection = () => ({
  type: CLEAR_COLLECTION_POINT_SELECTION,
});

export const setCollectionPointViewType = activeViewType => async (dispatch) => {
  const url = activeViewType === VIEW_TYPE_MAP ?
    routeConstants.CLICK_AND_COLLECT_SEARCH_MAP : routeConstants.CLICK_AND_COLLECT_SEARCH_LIST;

  await dispatch(push(url));

  dispatch({
    type: SET_COLLECTION_POINT_VIEW_TYPE,
    activeViewType,
  });
};

export const closeMoreDetailsModal = () => (dispatch) => {
  dispatch(goBack());
};

export const openMoreDetailsModal = ({ id = '', route }) => (dispatch) => {
  const path = `${route}/store-details/${id}`;
  dispatch(push(path));
};

export const setActiveMapMarker = marker => ({
  type: SET_ACTIVE_MAP_MARKER,
  marker,
});

export const setActiveModalMapMarker = marker => (dispatch) => {
  const url = routeConstants.CLICK_AND_COLLECT_STORE_DETAILS.replace(':id', marker.id);
  dispatch(replace(`${url}`));

  dispatch({
    type: SET_ACTIVE_MODAL_MAP_MARKER,
    marker,
  });
};

export const setFindCollectionPointError = error => ({
  type: SET_FIND_COLLECTION_POINT_ERROR,
  error,
});

export const openSavedCollectionPointsModal = () => async (dispatch) => {
  dispatch(push(routeConstants.CLICK_AND_COLLECT_SAVED_COLLECTION_POINTS));
};

export const changeClickAndCollectSelectedPoint = () => async (dispatch, getState) => {

  const savedCollectionPoints = get(getState(), 'user.collectionPoints', []);

  if (savedCollectionPoints.length > 1) {
    dispatch(openSavedCollectionPointsModal());
    return;
  }

  const url = get(getState(), 'clickAndCollect.activeViewType') === VIEW_TYPE_MAP ?
    routeConstants.CLICK_AND_COLLECT_SEARCH_MAP : routeConstants.CLICK_AND_COLLECT_SEARCH_LIST;

  dispatch(push(url));
  dispatch(newCollectionPointSearch());
};

export const initSavedCollectionPoint = (refresh = false) => (dispatch, getState) => {
  const state = getState();

  if (!get(state, 'clickAndCollect.selectedCollectionPointCleared')) {
    // TODO: What is relevance of collectionPointSearchComplete here?
    const collectionPointSearchComplete = get(state, 'clickAndCollect.collectionPointSearchComplete', false);
    const collectionPoint = determinePreSelectedCollectionPoint(get(state, 'user.collectionPoints', []));

    if (collectionPoint && !collectionPointSearchComplete) {
      return dispatch(selectCollectionPoint({ collectionPoint }));
    }

    // refresh means customer encountered inconsistent order form error so we need to refresh selected
    // collection point dates to get up to date fulfilmentOfferIds
    if (refresh && !isEmpty(state.clickAndCollect.selectedCollectionPoint)) {
      return dispatch(selectCollectionPoint({ collectionPoint: state.clickAndCollect.selectedCollectionPoint }));
    }
  }

  return null;
};

export const setClickCollectCountdownVisibility = visible => ({
  type: SET_CLICK_COLLECT_COUNTDOWN_VISIBILITY,
  visible,
});

export const setClickCollectCutOffPassed = cutOffPassed => ({
  type: SET_CLICK_COLLECT_CUT_OFF_PASSED,
  cutOffPassed,
});

export const handleCutOffPassedModalChangeDateClick = params => async (dispatch, getState) => {
  const {
    isPayment,
    modalVisible = true,
  } = params;

  const state = getState();
  const selectedCollectionPoint = get(state, 'clickAndCollect.selectedCollectionPoint', {});

  if (isPayment) {
    const url = routeConstants.CLICK_AND_COLLECT_STORE_SELECTED.replace(':id', selectedCollectionPoint.id);
    await dispatch(push(url));
  }

  if (modalVisible) {
    dispatch(setCutOffPassedModalVisibility(false));
  }

  dispatch(getCollectionPointDates({
    batchId: get(getState(), 'delivery.deliveries[0].id'),
    collectionPointId: selectedCollectionPoint.id,
  }));
};

export const deleteCollectionPoint = dtsfcLocationId => ({
  type: DELETE_COLLECTION_POINT,
  request: client => client({
    path: URL_DELETE_COLLECTION_POINT(dtsfcLocationId),
    config: {
      method: 'DELETE',
    },
  }),
});

export const showDeleteCollectionPointOverlay = id => ({
  type: SHOW_REMOVE_COLLECTION_POINT_OVERLAY,
  id,
});

export const hideDeleteCollectionPointOverlay = () => ({
  type: HIDE_REMOVE_COLLECTION_POINT_OVERLAY,
});

export const setGeoLocationSearchActiveStatus = active => ({
  type: SET_GEO_LOCATION_SEARCH_ACTIVE_STATUS,
  active,
});

export const onGoogleMapsScriptLoadSuccess = () => ({
  type: GOOGLE_MAPS_SCRIPT_LOADED,
});

export const collectionCutOffPassedDuringSubmitOrder = () => async (dispatch, getState) => {
  const state = getState();

  const availableDates = get(state, 'clickAndCollect.collectionPointDates', []).filter(({ isAvailable }) => isAvailable);
  if (isUndefined(availableDates[1])) {
    // no more available dates so fake an error response to avoid a pointless API call
    return dispatch({
      type: `${PUT_CC_DELIVERY_DETAILS_SILENTLY}.FAILED`,
    });
  }

  const fulfilmentOfferId = availableDates[1].fulfilmentOfferId;
  const collectorDetails = state.clickAndCollect.collectorDetails;
  const giftMessageLines = state.clickAndCollect.giftMessageLines;

  const body = {
    collectorDetails,
    fulfilment: {
      fulfilmentOfferId,
      giftMessageLines,
    },
  };

  return dispatch({
    type: PUT_CC_DELIVERY_DETAILS_SILENTLY,
    request: client => client({ path: URL_COLLECTION_DETAILS, config: { method: 'PUT', body } }),
  });
};
